import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { useGetAllMyLeafsQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import ClassDropDown from '../Header/components/ClassDropDown/ClassDropDown';

interface Props {
  teaching_structure_id: string;
  onSelect: any;
  selected: any;
}

const TeachingStructureDropDown: React.FC<Props> = ({
  teaching_structure_id,
  onSelect,
  selected,
}) => {
  const { t } = useTranslation();
  const [selectedTeachingStructure, setSelectedTeachingStructure] = useState({
    title: t('study:select_teaching_structure_item'),
    id: '',
  });

  const { data } = useGetAllMyLeafsQuery({
    variables: {
      teaching_structure_id,
    },
  });

  useEffect(() => {
    const item = _.find(data?.teaching_structure_leafs, ['id', selected]);
    if (item) {
      setSelectedTeachingStructure(item);
    }
  }, [selected, data]);

  function printItems() {
    return data?.teaching_structure_leafs.map(obj => {
      return (
        <div
          className={`dropdown-element pointer ${
            obj.id === selectedTeachingStructure.id && 'selected'
          }`}
          key={`${selectedTeachingStructure}-${obj.id}`}
          onClick={() => {
            setSelectedTeachingStructure(obj);
            onSelect(obj);
          }}
        >
          <div className={'mb-1'} key={obj.id}>
            <p>{obj.title}</p>
            <p className={'text-small'}>
              {data?.teaching_structure_leafs
                .filter(filterObj => {
                  return obj.rtl < filterObj.rtl && obj.ltr > filterObj.ltr;
                })
                .map(mapObj => {
                  return mapObj.title;
                })
                .join(' > ')}
            </p>
          </div>
        </div>
      );
    });
  }

  return (
    <ClassDropDown value={selectedTeachingStructure.title} icon={''}>
      <div>{printItems()}</div>
    </ClassDropDown>
  );
};

export default TeachingStructureDropDown;
